import { render, staticRenderFns } from "./CompanyActiveSelection.vue?vue&type=template&id=1ff0edca&scoped=true"
import script from "./CompanyActiveSelection.vue?vue&type=script&lang=js"
export * from "./CompanyActiveSelection.vue?vue&type=script&lang=js"
import style0 from "./CompanyActiveSelection.vue?vue&type=style&index=0&id=1ff0edca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0edca",
  null
  
)

export default component.exports